<template>

  <section class="o-section">
    <div class="o-section__wrapper is-bottom-left" ref="wrapper">

      <div class="o-section__text" v-if="active">
        <div ref="textA" data-scene="6a">
          <div v-for="line in copy.top" v-html="line" :key="line"></div>
        </div>
      </div>

      <div class="o-section__figure-wrapper anim-figure-scene-6">
        <figure class="o-section__figure" ref="figureC" data-scene="6c">
          <Img :src="require('@/assets/scene6/spread6_c.png')" filename="spread6_c" />
        </figure>

        <figure class="o-section__figure" ref="figureA2" data-scene="6a2">
          <Img :src="require('@/assets/scene6/spread6_a2.png')" filename="spread6_a2" />
        </figure>

        <figure class="o-section__figure" ref="figureA" data-scene="6a">
          <Img :src="require('@/assets/scene6/spread6_a.png')" filename="spread6_a" />
        </figure>

        <figure class="o-section__figure" ref="figureA4" data-scene="6a4">
          <Img :src="require('@/assets/scene6/spread6_a4.png')" filename="spread6_a4" />
        </figure>

        <figure class="o-section__figure" ref="figureA3" data-scene="6a3">
          <Img :src="require('@/assets/scene6/spread6_a3.png')" filename="spread6_a3" />
        </figure>

        <figure class="o-section__figure" ref="figureB" data-scene="6b">
          <Img :src="require('@/assets/scene6/spread6_b.png')" filename="spread6_b" />
        </figure>
      </div>
    </div>
  </section>

</template>

<script>
import Img from '@/components/Img'

export default {
  name: 'Scene6',
  props: ['options', 'active', 'copy', 'disableBlur'],

  mounted () {
    this.$root.$on('startScene6', () => {
      this.init()
    })
  },

  methods: {
    init () {
      this.$anime({
        targets: [this.$refs.figureA, this.$refs.figureA3, this.$refs.figureA4],
        translateY: ['35px', '0'],
        duration: this.options.durationLarge,
        easing: this.options.easing
      })

      this.$anime({
        targets: this.$refs.figureA4.querySelector('div'),
        translateY: ['0', '10px'],
        duration: this.options.durationRegular,
        easing: this.options.easing,
        loop: true,
        direction: 'alternate'
      })

      this.$anime({
        targets: this.$refs.figureA2,
        translateY: ['10px', '0'],
        loop: true,
        direction: 'alternate',
        duration: this.options.durationLarge,
        easing: this.options.easing
      })

      this.$anime({
        targets: this.$refs.figureB,
        opacity: [0, 1],
        delay: 200,
        duration: this.options.durationSmall,
        easing: this.options.easing
      })

      this.$anime({
        targets: this.$refs.figureC,
        opacity: [0, 1],
        delay: 500,
        duration: this.options.durationSmall,
        easing: this.options.easing
      })

      if (this.disableBlur) {
        this.$anime({
          targets: this.$refs.figureB,
          opacity: [0, 1],
          delay: 200,
          duration: this.options.durationRegular,
          easing: this.options.easing
        })

        this.$anime({
          targets: this.$refs.figureC,
          translateY: ['-50px', '0'],
          opacity: [0, 1],
          delay: 500,
          duration: this.options.durationLarge,
          easing: this.options.easing
        })
      } else {
        this.$anime({
          targets: this.$refs.figureB,
          filter: ['blur(5px)', 'blur(0px)'],
          delay: 200,
          duration: this.options.durationRegular,
          easing: this.options.easing
        })

        this.$anime({
          targets: this.$refs.figureC,
          translateY: ['-50px', '0'],
          filter: ['blur(20px)', 'blur(0px)'],
          delay: 500,
          duration: this.options.durationLarge,
          easing: this.options.easing
        })
      }
    }
  },

  components: {
    Img
  }
}
</script>
